export default "<template>\r\n  <v-file-input multiple label=\"File input\"></v-file-input>\r\n</template>\r\n";